import { AddBox, Article, CalendarMonth, CreditCard, Feed, Group, Handshake, Home, Hotel, InterpreterMode, Rule, Upload } from "@mui/icons-material";

const menuItems = [
    {
        title: 'Inicio',
        icon: Home,
        to: '/inicio'
    },
    {
        title: 'Mesas temáticas',
        icon: Feed,
        to: '/mesas'
    },
    {
        title: 'Agenda',
        icon: CalendarMonth,
        to: '/agenda'
    },
    {
        title: 'Inscripción',
        icon: AddBox,
        subitems: [
            {
                title: 'Instrucciones para ponentes',
                icon: Rule,
                to: '/instrucciones',
            },
            {
                title: 'Formulario de inscripción',
                icon: AddBox,
                to: '/inscripcion',
            },
            {
                title: 'Envío de resúmenes',
                icon: Upload,
                to: '/resumenes',
            },
            {
                title: 'Pagos',
                icon: CreditCard,
                to: '/pagos',
            }
        ]
    },
    {
        title: 'Comité Científico',
        icon: Group,
        to: '/comitecientifico'
    },
    {
        title: 'Aliados y patrocinadores',
        icon: Handshake,
        to: '/patrocinadores'
    },
    {
        title: 'Hospedajes',
        icon: Hotel,
        to: '/hospedajes'
    },
    {
        title: 'Conferencistas',
        icon: InterpreterMode,
        to: '/conferencistas'
    },
    {
        title: 'Memoria',
        icon: Group,
        to: '/memoria'
    }

    // Comite cientifico y de honor


]

export { menuItems }